import {
  Component,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  AfterViewInit,
  OnChanges,
  ElementRef,
  HostListener,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { CalendarTypeView, Calendar } from 'primeng/calendar';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  PMCalendarSelectionMode,
  PMCalendarSelectionModeEnum,
} from '@shared/models/types/PMCalendarSelectionMode';
import {
  DatePickerModule,
  DatePickerYearChangeEvent,
} from 'primeng/datepicker';
import { isPlatformServer } from '@angular/common';

@Component({
  standalone: true,
  selector: 'pm-calendar',
  imports: [DatePickerModule, FormsModule, ReactiveFormsModule],
  templateUrl: './pm-calendar.component.html',
  styleUrl: './pm-calendar.component.scss',
})
export class PmCalendarComponent implements AfterViewInit, OnChanges {
  @Input() ctrl = new FormControl<any>(null);
  @Input() placeholder: string | undefined = undefined;
  @Input() readonlyInput = false;
  @Input() showClear = false;
  @Input() inline = false;
  @Input() selectionMode: PMCalendarSelectionMode | undefined =
    PMCalendarSelectionModeEnum.SINGLE;
  @Input() showWeek = false;
  @Input() view: CalendarTypeView = 'date';
  @Input() selectedWeekNumber: number | undefined;
  @Input() modelValue: Date | Date[] | null = null;
  @Input() minDate?: Date | null | undefined;
  @Input() maxDate?: Date | null | undefined;
  @Input() disabledDates: Date[] = [];
  @Output() clickOutside = new EventEmitter();
  @Output() dateSelected = new EventEmitter();
  @Output() monthChanged = new EventEmitter<DatePickerYearChangeEvent>();
  @ViewChild('pCalendarComponent') pCalendarComponent!: Calendar;
  date!: Date | Date[];

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.clickOutside.emit();
    }
  }

  constructor(
    private eRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngAfterViewInit() {
    this.highlightSelectedWeek();
  }

  ngOnChanges(): void {
    if (this.modelValue) {
      this.date = this.modelValue;
    } else {
      this.date = this.ctrl.value;
    }
    // else {
    //   if (this.selectionMode === PMCalendarSelectionModeEnum.RANGE) {
    //     console.log("set array")
    //     this.date = [];
    //   }
    // }
    this.highlightSelectedWeek();
  }

  outsideClicked() {
    this.clickOutside.emit();
  }

  onSelect(date: Date) {
    if (this.selectionMode === 'range') return; //nie wiem

    this.date = date;
    this.dateSelected.emit(date);
  }

  removeHighlight() {
    const highlighted = document.querySelectorAll('.selected-week');
    Array.from(highlighted).forEach((h) => {
      h.classList.remove('selected-week');
    });
  }

  highlightSelectedWeek() {
    if (isPlatformServer(this.platformId)) return;
    window.requestAnimationFrame(() => {
      this.removeHighlight();
      if (!this.pCalendarComponent?.contentViewChild?.nativeElement) return;
      const trs: HTMLElement[] = Array.from(
        this.pCalendarComponent.contentViewChild.nativeElement.querySelectorAll(
          'tr'
        )
      );

      for (const tr of trs) {
        const td = tr.querySelector('td');
        if (td) {
          const weekNumber = td.querySelector('span')?.innerText;
          if (Number(weekNumber) === this.selectedWeekNumber) {
            (tr as HTMLElement).classList.add('selected-week');
            break;
          }
        }
      }
    });
  }

  onMonthChange($event: DatePickerYearChangeEvent) {
    this.monthChanged.emit($event);
  }
}
